import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "size", "priority"];
import { Box, Button, IconButton } from '@wix/design-system';
import { ChevronRight } from '@wix/wix-ui-icons-common/odeditor';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './siteLevelGateHomeOptimized.scss';
export const HeroSearchBar = _ref => {
  let onSubmit = _ref.onSubmit,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$iconOnly = _ref.iconOnly,
    iconOnly = _ref$iconOnly === void 0 ? false : _ref$iconOnly;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const submitCta = t('domains_search_gate.gate_revamp.searchbar.submit.cta');
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    autoFocus: false,
    showSearchIcon: true,
    hideFilters: true,
    hideClearButton: true,
    placeholder: t(compact ? 'domains_search_gate.new_searchbar.placeholder' : 'domains_search_gate.gate_revamp.searchbar.placeholder'),
    onSubmit: onSubmit,
    Layouts: {
      SearchContainer: _ref2 => {
        let children = _ref2.children,
          className = _ref2.className,
          props = _objectWithoutPropertiesLoose(_ref2, _excluded);
        return /*#__PURE__*/React.createElement(Box, _extends({
          direction: "vertical",
          backgroundColor: "#FFFFFF",
          width: "100%",
          zIndex: 1
        }, props, {
          className: [s.searchContainer, className].filter(Boolean).join(' ')
        }), children);
      },
      InputContainer: _ref3 => {
        let children = _ref3.children,
          props = _objectWithoutPropertiesLoose(_ref3, _excluded2);
        return /*#__PURE__*/React.createElement(Box, _extends({
          direction: "horizontal",
          verticalAlign: "middle",
          align: "space-between",
          width: "100%",
          padding: "8px",
          flex: 1,
          gap: "4px"
        }, props), children);
      },
      ActionButton: _ref4 => {
        let _icon = _ref4.children,
          _size = _ref4.size,
          _priority = _ref4.priority,
          props = _objectWithoutPropertiesLoose(_ref4, _excluded3);
        return iconOnly ? /*#__PURE__*/React.createElement(IconButton, _extends({}, props, {
          size: "medium",
          skin: "dark",
          priority: "primary",
          ariaLabel: submitCta
        }), /*#__PURE__*/React.createElement(ChevronRight, null)) : /*#__PURE__*/React.createElement(Button, _extends({}, props, {
          size: compact ? 'medium' : 'large',
          skin: "dark"
        }), submitCta);
      },
      ToolBarContainer: () => /*#__PURE__*/React.createElement(React.Fragment, null)
    }
  });
};
//# sourceMappingURL=HeroSearchBar.js.map